import { Stack, Typography } from '@mui/material';
import React from 'react';
const RenderForbidden = () => {
    return (React.createElement(React.Fragment, null,
        React.createElement(Stack, { direction: 'column', alignItems: 'center', justifyContent: 'center', sx: (theme) => ({
                width: '100%',
                height: '100%',
                padding: theme.spacing(2),
            }) },
            React.createElement(Typography, { align: 'center', variant: 'body1', component: 'span' }, "\u0414\u043E\u0441\u0442\u0443\u043F \u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0435\u043D"),
            React.createElement(Typography, { align: 'center', color: 'text.secondary', variant: 'caption', component: 'span' }, "\u041F\u043E\u0434 \u0432\u0430\u0448\u0435\u0439 \u0443\u0447\u0435\u0442\u043D\u043E\u0439 \u0437\u0430\u043F\u0438\u0441\u044C\u044E \u0434\u043E\u0441\u0442\u0443\u043F \u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0435\u043D"))));
};
export default RenderForbidden;
